export enum ERoutes {
  FORM = 'form',
  TERMS = 'terms-and-conditions',
  SEARCH = 'search',
  BOOKING = 'booking',
  CARD = 'card'
}
